$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Backbone = require 'backbone'
Data = require '../data'
Hammer = require 'hammerjs'
{ delay, defaults } = require 'lodash'
{ toAngle, getHeight } = require '../../components/math'
{ parse } = require '../../components/query-string'

module.exports =
class OnePageScroll extends Singleton

  selector        : '.section'
  contentsSelector: '.contents-container'
  isLocatedClass  : 'is-located'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded': @onPagesLoaded
        'splashEnded': @on
      .on
        'detailOpenBefore.all': @off
        'detailCloseAfter.all': @on
    @$body        = Elements.$body
    @$wrap        = Elements.$wrap
    @$sections    = Elements.$sections
    @$sectionsInr = Elements.$sectionsInr

    @winH  = @$window.height()
    @overH = @getOverH()

    @ua      = navigator.userAgent.toLowerCase()
    @isSfari =
      if @ua.indexOf('safari') isnt -1
        true
      else
        false

    @location             = 0
    @beforeLocation       = 0
    @isFirstMousewheel    = true
    @mousewheeledLastTime = null
    @stopMousewheelTimer  = null
    @mousewheeledTotalX   = 0
    @mousewheeledTotalY   = 0
    @mousewheelDisable    = false
    @isInertia            = false

    @hammer = new Hammer @$wrap.get(0)
    @hammer
      .get 'swipe'
      .set
        enable   : true
        direction: Hammer.DIRECTION_VERTICAL
    @isTouchEvent = @hammer.input.evTarget

  on: =>
    @$window.on 'keyup', @onKeyup
    @$sectionsInr.on 'mousewheel', @onWindowMousewheeled
    if @isTouchEvent
      @hammer.on 'swipeup'  , @next
      @hammer.on 'swipedown', @prev

  off: =>
    @$window.off 'keyup', @onKeyup
    @$sectionsInr.off 'mousewheel', @onWindowMousewheeled
    if @isTouchEvent
      @hammer.off 'swipeup'  , @next
      @hammer.off 'swipedown', @prev

  onPagesLoaded: =>
    @$window.on 'resize', @onWindowResized

    @$section   = $ @selector

    @sectionLen = @$section.length

    @$section.eq(@location).siblings()
      .css
        display: 'none'
      .velocity
        translateY: '100%'
      , duration: 0

  onWindowResized: =>
    @winH  = @$window.height()
    @overH = @getOverH()

  onKeyup: (e) =>
    switch e.keyCode
      when 38
        @prev()
      when 40
        @next()

  onWindowMousewheeled: (e) =>
    @checkMousewheelStoped()

    return if @mousewheelDisable

    scrollLine =
      if @isInertia then 10 else 0

    @mousewheeledTotalX += e.deltaX
    @mousewheeledTotalY += e.deltaY

    x = @mousewheeledTotalX
    y = @mousewheeledTotalY

    reloadTime =
      if @isSfari then 1000 else 500

    if (-scrollLine > x) or (scrollLine < x)
      @mousewheelDisable = true

    if (-scrollLine > y) or (scrollLine < y)
      time = Date.now()

      if ((0 > e.deltaY) and (@location is 0)) or
         ((0 < e.deltaY) and (@location is 6))
        @mousewheeledLastTime = null

      if reloadTime < (time - @mousewheeledLastTime) or !@mousewheeledLastTime
        if 0 > e.deltaY then @next() else @prev()

      @mousewheeledLastTime = time

  checkMousewheelStoped: ->
    clearTimeout @stopMousewheelTimer
    if @isFirstMousewheel
      @isFirstMousewheel = false
    else
      @isInertia = true
    @stopMousewheelTimer = setTimeout =>
      @mousewheeledTotalX = 0
      @mousewheeledTotalY = 0
      @mousewheelDisable  = false
      @isFirstMousewheel  = true
      @isInertia          = false
    , 30

  prev: =>
    return if (0 >= @location)
    @move @location - 1

  next: =>
    return if ((@sectionLen - 1) <= @location)
    @move @location + 1

  move: (location) =>
    target = Data.directory[location]
    query  = $.param Data.params[location]
    fragment =
      if query then "#{target}?#{query}" else target
    Backbone.history.navigate fragment, true

  goTo: (target) ->
    @beforeLocation = @location
    @location       = target

    y =
      if @beforeLocation < target
        [ '-25%', '100%' ]
      else
        [ '25%', '-100%' ]

    @$section.eq @beforeLocation
      .removeClass @isLocatedClass

    if target
      if @beforeLocation
        @slideAnime @beforeLocation, 0, [y[0], 0],
          complete: @pageHide
      @slideAnime target, 1, [0, y[1]],
        complete: => @slideAnimated target
    else
      @slideAnime @beforeLocation, 0, [(@winH + @overH), 0],
        duration: 1000
        complete: => @slideAnimated target
      @$section.eq target
        .velocity
          translateY: 0
        ,
          duration: 0
          display : 'block'

  pageHide: =>
    @$section.not ":eq(#{@location})"
      .css
        display: 'none'
        zIndex : -1
      .velocity
        translateY: '-200%'
      , { duration: 0 }

  slideAnimated: =>
    @pageHide()
    @$section.eq @location
      .addClass @isLocatedClass
    @beforeLocation = @location

  slideAnime: (index, zIndex, y, opts) ->
    $el = @$section.eq index

    opts = defaults opts,
      duration: 500
      easing  : 'easeOutCubic'
      begin   : ->
        $el.css
          display: 'block'
          zIndex : zIndex

    $el
      .velocity 'stop'
      .velocity
        translateY: y
      , opts

  getOverH: ->
    getHeight @$window.width(), toAngle(10)



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/one-page-scroll.coffee